import { GameBackgroundProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameBackgroundProperties";
/**
 * BackgroundLandscapeProperties.ts
 */
export class BackgroundLandscapeProperties extends GameBackgroundProperties {
    constructor() {
        super();
        this.position.set(973, 512);
        this.scale.set(0.73);
    }
}
//# sourceMappingURL=BackgroundLandscapeProperties.js.map